var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('div',{staticClass:"close-layer",class:{ visible: _vm.$sidebar.showSidebar },on:{"click":_vm.toggleSidebar}}),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.dashboardLabel,
          path: '/pages/dashboard',
          icon: 'fa fa-tachometer-alt',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.messagesLabel,
          path: '/pages/messages',
          icon: 'fa fa-comments',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Calendar',
          path: '/pages/calendar',
          icon: 'fa fa-calendar-alt',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Shifts',
          path: '/pages/shifts',
          icon: 'fa fa-calendar-check',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.timeOffLabel,
          path: '/pages/time-off',
          icon: 'fa fa-umbrella-beach',
        }}}),(!_vm.isCaregiver)?_c('sidebar-item',{attrs:{"link":{
          name: 'Authorizations',
          path: '/pages/authorizations',
          icon: 'fa fa-file-signature',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Reports',
          path: '/pages/reports',
          icon: 'fa fa-chart-bar',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Payments',
          path: '/pages/payment-tracking',
          icon: 'fa fa-credit-card',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Caregivers',
          path: '/pages/caregivers',
          icon: 'fa fa-user-nurse',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Clients',
          path: '/pages/clients',
          icon: 'fa fa-users',
        }}}),(!_vm.isCaregiver)?_c('sidebar-item',{attrs:{"link":{
          name: 'Counselors',
          path: '/pages/counselors',
          icon: 'fa fa-user-tie',
        }}}):_vm._e(),(!_vm.isCaregiver)?_c('sidebar-item',{attrs:{"link":{
          name: 'Offices',
          path: '/pages/offices',
          icon: 'fa fa-building',
        }}}):_vm._e(),(!_vm.isCaregiver)?_c('sidebar-item',{attrs:{"link":{
          name: 'Payroll',
          path: '/pages/payroll',
          icon: 'fa fa-money-bill-wave',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{ name: 'Admin', path: '/pages/admin', icon: 'fa fa-cog' }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{ name: 'Settings', icon: 'fa fa-sliders' }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Service Codes', path: '/pages/settings/service-codes' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Non-Service Codes', path: '/pages/settings/non-service-codes' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'DSPD Questions', path: '/pages/settings/dspd-shift-questions' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'VR Questions', path: '/pages/settings/vr-shift-questions' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'VR Activities', path: '/pages/settings/vr-activity-lists' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'DSPD Email Alerts', path: '/pages/settings/dspd-email-alerts' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'AI Email Prompts', path: '/pages/settings/ai-email-prompts' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Mileage', path: '/pages/settings/mileage-settings' }}})],1):_vm._e(),(!_vm.isCaregiver)?_c('sidebar-item',{attrs:{"link":{
          name: 'CBS Programs',
          path: '/pages/cbs-programs',
          icon: 'fa fa-sitemap',
        }}}):_vm._e(),(!_vm.isCaregiver)?_c('sidebar-item',{attrs:{"link":{
          name: 'Compliance',
          path: '/pages/compliance-dashboard',
          icon: 'fa fa-clipboard-check',
        }}}):_vm._e(),(!_vm.isCaregiver)?_c('sidebar-item',{attrs:{"link":{
          name: 'Verification',
          path: '/pages/verification',
          icon: 'fa fa-shield-alt',
        }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{ name: 'Audit Logs', path: '/pages/audit-logs', icon: 'fa fa-clipboard-list' }}}):_vm._e(),(_vm.isAdmin)?_c('sidebar-item',{attrs:{"link":{ name: 'Help', path: '/pages/help', icon: 'fa fa-circle-question' }}}):_vm._e()],1)],2),_c('div',{ref:"mainPanel",staticClass:"main-panel"},[_c('top-navbar'),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }